<template>
  <div id="account-header" class="account-header" v-bind:class="{
    'row-header': ['xs', 'sm', 'md'].includes($vuetify.breakpoint.name)
  }">
    <nav
        class="castfy-menu"
        v-bind:class="{'flex': ['xs'].includes($vuetify.breakpoint.name) && !showMenu}"
    >
      <v-btn
          type="button"
          class="box box__primary box__square box__light box__menu_toggler condensed"
          v-if="['xs', 'sm'].includes($vuetify.breakpoint.name)"
          @click.prevent="showMenu = !showMenu"
      >
        Menu
      </v-btn>
      <v-list
          v-bind:class="{
            'show': ['md', 'lg', 'xl'].includes($vuetify.breakpoint.name) || this.showMenu
          }"
      >
        <v-row no-gutters>
          <v-col cols="12" md="5" lg="12">
            <v-list-item
                class="box box__primary box__light box__menu_item"
                :to="{name: 'ContractorAccountAgenda'}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__calendar"></v-icon>
              </v-list-item-icon>
              <span class="condensed">Meus eventos</span>
            </v-list-item>
          </v-col>

          <v-col cols="12" md="5" lg="12">
            <v-list-item
                class="box box__primary box__light box__menu_item"
                :to="{name: 'ContractorJobForm'}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__new"></v-icon>
              </v-list-item-icon>
              <span class="condensed">Criar Job</span>
            </v-list-item>
          </v-col>

          <v-col cols="12" md="5" lg="12">
            <v-list-item
                class="box box__primary box__light box__menu_item"
                :to="{name: 'ContractorJobHistory'}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__history"></v-icon>
              </v-list-item-icon>
              <span class="condensed">Histórico de Jobs</span>
            </v-list-item>
          </v-col>

          <v-col cols="12" md="5" lg="12">
            <v-list-item
                class="box box__primary box__light box__menu_item"
                :to="{name: 'CastSearch', params: {clear: true}}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__eye" style="font-size: 18px !important"></v-icon>
              </v-list-item-icon>
              <span class="condensed">Explorar</span>
            </v-list-item>
          </v-col>

          <v-col cols="12" md="5" lg="12">
            <v-list-item
              class="box box__primary box__light box__menu_item"
              :to="{name: 'ContractorWallet', params: {clear: true}}"
              active-class="active"
            >
              <v-list-item-icon>
                <v-icon>wallet</v-icon>
              </v-list-item-icon>
              <span class="condensed">Demonstrativo financeiro</span>
            </v-list-item>
          </v-col>

          <v-col cols="12" md="5" lg="12">
            <v-list-item
                class="box box__primary box__light box__menu_item"
                :to="{name: 'ContractorProfile'}"
                active-class="active"
            >
              <v-list-item-icon
                  v-if="$store.state.session.user.photo_images && $store.state.session.user.photo_images.user_default">
                <div
                    class="media-preview"
                    :style="`background-image:url('${$store.state.session.user.photo_images.user_default}')`"
                    @click="$refs['changeProfilePicture'] ? $refs['changeProfilePicture'].selectProfilePicture() : null"
                ></div>
              </v-list-item-icon>
              <v-list-item-icon v-else>
                <v-icon>person</v-icon>
              </v-list-item-icon>
              <span class="condensed">Dados do Perfil</span>
            </v-list-item>
          </v-col>
        </v-row>
      </v-list>

      <v-list class="show current-menu-item" v-if="['xs', 'sm'].includes($vuetify.breakpoint.name) && !showMenu">
        <v-row no-gutters>
          <v-col
              cols="12"
              md="5"
              lg="12"
              v-if="['ContractorAccountCalendar', 'ContractorEventList', 'EventDetails', 'ProfessionalReplace', 'ProfessionalFinder'].includes($route.name)"
          >
            <v-list-item
                class="box box__secondary box__light box__menu_item"
                :to="{name: 'ContractorAccountAgenda'}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__calendar"></v-icon>
              </v-list-item-icon>
              <span class="condensed" v-if="['sm'].includes($vuetify.breakpoint.name)">Meus eventos</span>
            </v-list-item>
          </v-col>

          <v-col
              cols="12"
              md="5"
              lg="12"
              v-if="['ContractorJobForm', 'ContractorEventForm', 'ContractorCloneEventForm', 'EventCheckout'].includes($route.name)"
          >
            <v-list-item
                class="box box__secondary box__light box__menu_item"
                :to="{name: 'ContractorJobForm'}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__new"></v-icon>
              </v-list-item-icon>
              <span class="condensed" v-if="['sm'].includes($vuetify.breakpoint.name)">Criar Job</span>
            </v-list-item>
          </v-col>

          <v-col
              cols="12"
              md="5"
              lg="12"
              v-if="['ContractorJobHistory', 'ContractorEventSurvey'].includes($route.name)"
          >
            <v-list-item
                class="box box__secondary box__light box__menu_item"
                :to="{name: 'ContractorJobHistory'}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__history"></v-icon>
              </v-list-item-icon>
              <span class="condensed" v-if="['sm'].includes($vuetify.breakpoint.name)">Histórico de Jobs</span>
            </v-list-item>
          </v-col>

          <v-col
              cols="12"
              md="5"
              lg="12"
              v-if="['CastSearch', 'CastSearchProfile'].includes($route.name)"
          >
            <v-list-item
                class="box box__secondary box__light box__menu_item"
                :to="{name: 'CastSearch', params: {clear: true}}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__eye" style="font-size: 18px !important"></v-icon>
              </v-list-item-icon>
              <span class="condensed" v-if="['sm'].includes($vuetify.breakpoint.name)">Explorar</span>
            </v-list-item>
          </v-col>

          <v-col
              cols="12"
              md="5"
              lg="12"
              v-if="$route.name === 'ContractorProfile'"
          >
            <v-list-item
                class="box box__secondary box__light box__menu_item"
                :to="{name: 'ContractorProfile'}"
                active-class="active"
            >
              <v-list-item-icon v-if="$store.state.session.user.photo_images && $store.state.session.user.photo_images.user_default">
                <div
                    class="media-preview"
                    :style="`background-image:url('${$store.state.session.user.photo_images.user_default}')`"
                    @click="$refs['changeProfilePicture'] ? $refs['changeProfilePicture'].selectProfilePicture() : null"
                ></div>
              </v-list-item-icon>
              <v-list-item-icon v-else>
                <v-icon>person</v-icon>
              </v-list-item-icon>
              <span class="condensed" v-if="['sm'].includes($vuetify.breakpoint.name)">Dados do Perfil</span>
            </v-list-item>
          </v-col>
        </v-row>
      </v-list>
    </nav>
    <v-row
        v-bind:class="{'justify-end align-content-end': ! ['xs', 'sm', 'md'].includes($vuetify.breakpoint.name)}"
    >
      <ChangeProfilePicture view="contractor"
                            v-if="$route.name === 'ContractorProfile' && !['xs', 'sm', 'md'].includes($vuetify.breakpoint.name)"></ChangeProfilePicture>
    </v-row>
    <ChangeProfilePicture view="contractor" v-if="$route.name === 'ContractorProfile' && ['xs', 'sm', 'md'].includes($vuetify.breakpoint.name)" ref="changeProfilePicture" hidden></ChangeProfilePicture>

  </div>
</template>

<script>
import ChangeProfilePicture from '@/components/Account/components/ChangeProfilePicture/Index'
import getApiClient from '@/plugins/api-client'

export default {
  name: 'ContractorAccountHeader',
  data: function () {
    return {
      showMenu: true,
      newJobs: 0
    }
  },
  components: {
    ChangeProfilePicture
  },
  methods: {
    fetchNewJobs() {
      const self = this,
          api = getApiClient(self.$store)

      api.get('/jobs', {
        params: {
          status: 0,
          'event.start[after]': new Date()
        }
      })
          .then(result => {
            self.newJobs = result.data['hydra:totalItems']
          })
          .catch(error => {
            console.log(error)
          })
    },
  },
  mounted() {
    this.fetchNewJobs()
  }
}
</script>
